'use client';
import { Icon } from '@/app/common';

interface PlayButtonProps {
  onPlay: () => void;
  variant?: 'default' | 'white';
  className?: string;
  ariaLabel?: string;
}

export function PlayButton({ onPlay, variant = 'default', className = '', ariaLabel = 'Play video' }: PlayButtonProps) {
  const iconName = variant === 'white' ? 'PlayCircleWhite' : 'PlayCircle';
  const iconClassName =
    variant === 'white'
      ? 'w-10 h-10 text-white cursor-pointer'
      : 'w-12 h-12 text-primary cursor-pointer md:w-10 md:h-10';

  return (
    <button
      type="button"
      className={`p-2xs cursor-pointer relative z-20 ${className}`}
      aria-label={ariaLabel}
      onClick={(e) => {
        e.stopPropagation();
        onPlay();
      }}
    >
      <Icon name={iconName} className={iconClassName} />
    </button>
  );
}
